@import 'styles/mixins';

.container {
  display: grid;
  grid-template-columns: repeat(5, minmax(180px, 1fr));
  gap: 16px;
  position: relative;

  @include for-phone-only {
    display: flex;
  }
}

.loadingOverlay {
  background: var(--light-100);
  bottom: 0;
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}

.post {
  align-items: flex-start;
  background: var(--light-20);
  border-radius: 10px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @include for-phone-only {
    width: 200px;
  }

  .preview {
    align-items: center;
    display: flex;
    flex: 1 0 0;
    padding: 15px;
  }

  .data {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    padding: 15px 15px 10px 15px;
    flex-direction: column;

    .engagement {
      align-items: flex-start;
      align-self: stretch;
      border-bottom: 1px solid var(--dark-4);
      display: flex;
      padding-bottom: 10px;
      flex-direction: column;
      justify-content: center;
    }

    .more {
      align-items: flex-start;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      gap: 7px;

      .itemsContainer {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        width: 100%;

        .item {
          align-items: center;
          align-self: stretch;
          border-bottom: 1px solid var(--dark-4);
          display: flex;
          padding: 2px 0px 4px 0px;
          gap: 4px;
          justify-content: space-between;
        }
      }

      .footer {
        width: 100%;
      }
    }
  }

  .postButton {
    display: flex;

    /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
    @media (max-width: 1485px) {
      flex-direction: column;
      gap: 2px;

      .nonBreakingSpace {
        display: none;
      }
    }
  }
}

.emptyContainer {
  background: var(--light-100, #fff);
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset, 0 2px 12px var(--dark-4);
  padding: 15px;
  position: relative;
  width: 100%;

  .innerContainer {
    align-items: center;
    background-color: rgba(0, 0, 0, 0.03);
    flex-direction: column;
    gap: 15px;
    display: flex;
    padding: 20px;
    text-align: center;
    width: 100%;
  }
}
